import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { WHATSAPP } from "./data";

const LINKS = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "₹999 Consult", href: "#consult" },
  { label: "Founder", href: "#founder" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-[110] transition-colors duration-500 ${
        scrolled
          ? "border-b border-[hsl(var(--border))] bg-[hsl(var(--bg)/0.72)] backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-logo text-2xl font-bold italic tracking-tight text-[hsl(var(--fg))] md:text-3xl"
        >
          Design<span className="text-[hsl(var(--primary))]">4</span>you
        </a>

        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="group relative text-sm text-[hsl(var(--muted))] transition-colors duration-300 hover:text-[hsl(var(--fg))]"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[hsl(var(--primary))] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-book-btn"
            className="hidden items-center gap-2 rounded-full bg-[hsl(var(--primary))] px-5 py-2.5 text-sm font-semibold text-[hsl(var(--primary-fg))] transition-transform duration-300 hover:scale-105 sm:flex"
          >
            <MessageCircle size={16} /> Book a Call
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-menu-btn"
            className="text-[hsl(var(--fg))] md:hidden"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-[hsl(var(--border))] bg-[hsl(var(--bg))] md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                  className="py-2.5 text-base text-[hsl(var(--fg))]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noreferrer"
                data-testid="mobile-nav-book-btn"
                className="mt-2 rounded-full bg-[hsl(var(--primary))] py-3 text-center font-semibold text-[hsl(var(--primary-fg))]"
              >
                Book a Call
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
